import React, { useState } from 'react';
import { useFormik } from 'formik';
import {
	DisputeFieldsTypes,
	getDisputeDetailSchema,
	initialDisputeValues
} from '../../constants/dispute/dispute-form';
import { DisputeInputs } from '../../constants/dispute/dispute-inputs';
import { DisputeFormInputs } from '../orders/DisputeFormInputs';
import { BUTTON_TYPE, ButtonComponent } from '../ButtonComponent';
import { usePaymentContext } from '../../store/payments/payments-context';
import { setDispute } from '../../store/payments/actions/disputes';
import { IOrderHateoasLinks } from '../orders/OrderDetails';
import { useDisputesContext } from '../../store/disputes/disputes-context';

const CARD_TYPES = [
	{
		value: 'Visa',
		label: 'VISA'
	},
	{
		value: 'Mastercard',
		label: 'MASTERCARD'
	},
	{
		value: 'American Express',
		label: 'AMERICAN EXPRESS'
	},
	{
		value: 'Discover',
		label: 'DISCOVER'
	}
];

const MANAGER_SYSTEMS = [
	{
		value: 'Ethoca',
		label: 'Ethoca'
	},
	{
		value: 'Verifi RDR',
		label: 'Verifi RDR'
	},
	{
		value: 'Verifi CDRN',
		label: 'Verifi CDRN'
	},
	{
		value: 'Stripe',
		label: 'Stripe'
	},
	{
		value: 'Nuvei',
		label: 'Nuvei'
	},
	{
		value: 'Nmi',
		label: 'Nmi'
	},
];

interface Props {
	closeModal: () => void;
	onSuccess: () => void;
	onError: () => void;
	orderId: string | number;
	disputeAction: IOrderHateoasLinks
}

export const DisputeForm = (props: Props): React.ReactElement => {
	const { onError, onSuccess, closeModal, orderId, disputeAction } = props;
	const { paymentContextState: { disputeTypes, isAddingDisputeLoading }, dispatch } = usePaymentContext();
	const { disputesContextState } = useDisputesContext();

	console.log('disputesContextState---', disputesContextState);

	const [error, setError] = useState<string>('');

	const formik = useFormik<DisputeFieldsTypes>({
		initialValues: initialDisputeValues,
		validationSchema: getDisputeDetailSchema,
		onSubmit: async () => await setDispute({
			dispatch, formik,
			onSuccess, onError,
			orderId, setError,
			disputeAction
		})
	});

	const INPUTS = DisputeInputs(
		CARD_TYPES,
		(disputesContextState?.managementSystem || []).map(el => ({ value: el, label: el })),
		disputeTypes);

	return (
		<form onSubmit={formik.handleSubmit} className="row px-8">
			{
				INPUTS.map(el => (
					<DisputeFormInputs formik={formik} {...el} key={el.key} />
				))
			}
			<div className="text-danger mt-10">{error}</div>
			<div className="text-center my-5">
				<ButtonComponent
					buttonName="Cancel"
					buttonType={BUTTON_TYPE.CANCELLED}
					additionalClass="btn-sm"
					onButtonClick={closeModal}
				/>
				<ButtonComponent
					buttonName="Confirm"
					type="submit"
					additionalClass="btn-sm ms-10 w-100px"
					loading={isAddingDisputeLoading}
					isDisabled={isAddingDisputeLoading}
				/>
			</div>
		</form>
	);
};
